'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pink = {};

exports.__exports = pink;
